import { IAdmin } from "interfaces";
import api from 'requests/api';

export const me = async (): Promise<IAdmin> => {
  const { data } = await api.get(`/admin/admins/me`);

  return data;
};
